import { Features } from 'src/app/state/types/loc-profile';
import { useFeatureCheck } from 'src/app/state/user-dispensaries';

export const useLoyaltyBoosters = () => useFeatureCheck(Features.LoyaltyAndMarketingSubscriber);
